import '../styles/Primitives.scss';

export default function DialogTitle({ children, className = '', ...props }) {
  return <h2 className={`ui-dialog-title ${className}`.trim()} {...props}>{children}</h2>;
}
